import React, {Component} from 'react';
import {Scrollbars} from 'react-custom-scrollbars';
import {List} from 'react-virtualized';

const listStyle = {
    overflowX: false,
    overflowY: false,
};
export default class SmartList extends Component {
    handleScroll = ({target}) => {
        const {scrollTop, scrollLeft} = target;
        const {Grid: grid} = this._list;
        grid.handleScrollEvent({scrollTop, scrollLeft});
    };
    scrollToTop = (position) => {
        if (this._scroll) {
            this._scroll.scrollTop(position || 0);
        }
    };
    _list = null;
    _scroll = null;

    render() {
        const {width, height} = this.props;
        return <Scrollbars
            ref={instance => (this._scroll = instance)}
            autoHide
            style={{width, height}}
            onScroll={this.handleScroll}>
            <List
                {...this.props}
                ref={instance => (this._list = instance)}
                style={listStyle}/>
        </Scrollbars>
    }
}


// WEBPACK FOOTER //
// ./src/SmartList.js